import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";

@Injectable({
	providedIn: "root"
})
export class UserTypesService {

	constructor(
		private http: HttpService
	) { }

	createUserType(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/createUserType", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	updateUserType(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/updateUserType", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	removeUserType(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/removeUserType", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	createUserFields(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/createFields", true, data).then(res => {
			});
		});
	}
	getByIdToEdit(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/getByIdToEdit", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	verifyPermissions(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/verifyPermissions", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	getAdminRequest(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/getAdminRequest", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	setApproval(data: any) {
		return new Promise((resolve, reject) => {
			this.http.post("api/user-types/user-types/setApproval", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

}
